import "./GlobalStyle.css";
import "./PCStyle.css";
import "./TabletStyle.css";
import "./MobileStyle.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import GNB from "./Components/GNB";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Service1 from "./Pages/Service1";
import Service2 from "./Pages/Service2";
import Service3 from "./Pages/Service3";
import Portfolio from "./Pages/Portfolio";
import Contact from "./Pages/Contact";
import Footer from "./Components/Footer";
import styled from "styled-components";
import ScrollToTop from "./Utils/ScrollToTop";

function App() {
  return (
    <AppContainer>
      <BrowserRouter>
        <GNB />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services1" element={<Service1 />} />
          <Route path="/services2" element={<Service2 />} />
          <Route path="/services3" element={<Service3 />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </AppContainer>
  );
}

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: "center";
  width: 100%;
`;

export default App;
